import axios from 'axios';
import router from '@/router';
// const { targetUrl } = require('config/env');
var isProd = process.env.NODE_ENV === 'production';
// axios 默认配置
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.timeout = 30000; // 设置30s为超时
// 存储路由跳转时，需要cancel的接口
var requestMap = new Map();
var baseUrl = isProd ? window.location.protocol + "//" + window.location.host : '/';
var instance = axios.create({
    baseURL: baseUrl,
});
/**
 * 请求拦截
 */
instance.interceptors.request.use(function (config) {
    if (config.cancelToken) {
        var source = axios.CancelToken.source();
        config.axiosKey = config.url.split('?')[0];
        config.cancelToken = source.token;
        // 如果存在就未完结的就cancel
        if (requestMap.has(config.axiosKey) && (!config.params || !config.params.allowRepeat)) {
            requestMap.get(config.axiosKey).cancel();
        }
        requestMap.set(config.axiosKey, source);
    }
    return config;
});
/**
 * 结果拦截
 */
instance.interceptors.response.use(function (response) {
    var axiosKey = response.config.axiosKey;
    requestMap.delete(axiosKey);
    return response;
});
/**
 * 监听路由变化，取消全部待取消的请求
 */
router.beforeEach(function (to, from, next) {
    // 遍历全部取消
    // console.log('待取消请求的数目：', requestMap.size);
    if (requestMap.size > 0) {
        requestMap.forEach(function (item, key) {
            item.cancel();
            requestMap.delete(key);
        });
    }
    next();
});
export default instance;
